import { toast, ToastOptions, Slide, Id } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const useToast = () => {
    const defaultOptions: ToastOptions = {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        transition: Slide,
    };

    const showSuccess = (
        message: string,
        options: ToastOptions & { toastId?: Id } = {}
    ) => {
        toast.success(message, { ...defaultOptions, ...options });
    };

    const showError = (
        message: string,
        options: ToastOptions & { toastId?: Id } = {}
    ) => {
        toast.error(message, { ...defaultOptions, ...options });
    };

    const showInfo = (
        message: string,
        options: ToastOptions & { toastId?: Id } = {}
    ) => {
        toast.info(message, { ...defaultOptions, ...options });
    };

    const showWarning = (
        message: string,
        options: ToastOptions & { toastId?: Id } = {}
    ) => {
        toast.warning(message, { ...defaultOptions, ...options });
    };

    return { showSuccess, showError, showInfo, showWarning };
};
